import { render, staticRenderFns } from "./VoteModule.vue?vue&type=template&id=73254672"
import script from "./VoteModule.vue?vue&type=script&lang=ts"
export * from "./VoteModule.vue?vue&type=script&lang=ts"
import style0 from "./VoteModule.vue?vue&type=style&index=0&id=73254672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports